import React, { useContext, useState } from 'react';
import { Button, Popover } from 'antd';
import { ThemeContext } from '../../context/themeProvider';
import { COLOR_THEME } from '../../utils/constants';

const ThemeChangeSettings = ({ onClose }) => {
  const { changeTheme } = useContext(ThemeContext);
  const [selectedColor, setSelectedColor] = useState(localStorage.getItem(COLOR_THEME) ?? '#1890FF'); // Default selected color

  const colors = [
    { name: 'Purple', color: '#7C3AED' },
    { name: 'Red', color: '#FF4D4F' },
    { name: 'Blue', color: '#1890FF' },
    { name: 'Pink', color: '#EB2F96' },
    { name: 'Cyan', color: '#13C2C2' },
  ];
  // Function to handle color change
  const handleColorChange = (color) => {
    setSelectedColor(color); // Update selected color
    changeTheme(color); // Change the theme
    onClose();
  };

  // Popover content - the color options
  const colorOptions = (
    <div style={{ display: 'flex', gap: '.375rem' }}>
      {colors.map((colorOption) => (
        <Button
          key={colorOption.name}
          type="primary"
          shape="circle"
          style={{
            backgroundColor: colorOption.color,
            borderColor: colorOption.color,
            minWidth: '16px',
            maxWidth: '16px',
            maxHeight: '16px',
            minHeight: '16px',
          }}
          onClick={() => handleColorChange(colorOption.color)} // Change theme and selected color on click
        />
      ))}
    </div>
  );

  return (
    <Popover content={colorOptions} trigger="click" placement="top" overlayClassName="theme-color-popover">
      <Button
        className="theme-color-main-button" // Added for easier selection
        type="primary"
        shape="circle"
        style={{
          backgroundColor: selectedColor,
          borderColor: selectedColor,
          minWidth: '16px',
          maxWidth: '16px',
          maxHeight: '16px',
          minHeight: '16px',
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
    </Popover>
  );
};

export default ThemeChangeSettings;
